import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Form, FormGroup, Input, Col, Label } from 'reactstrap';

const DisputeModal = (props) => {
    const {
        modalDetails,
        modalTopic,
        modalResponse,
        toggle,
        yesAction,
        yesText,
        noText,
        disputeValue,
        commentDispute,
        handleFileChange,
        handleInputChange,
        valueDispute,
        commentValue,
        showForm,
        requesting
    } = props;

   return (
        <div>
            <Modal isOpen={props.isOpen} toggle={toggle} className={"toggle"}>
                <ModalHeader toggle={toggle}>{modalTopic}</ModalHeader>
                <ModalBody>
                {modalResponse}
                    {modalDetails}
                {showForm &&
                <Form style={{marginLeft: "30px"}}>
                    <Row>
                        <Col lg="4">
                            <FormGroup>
                                <Label>Dispute Value</Label>
                                <Input type="text"
                                    name="valueDispute"
                                    size="30"
                                    onChange={handleInputChange}
                                    value={valueDispute}
                                >{disputeValue}</Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="4">
                            <FormGroup>
                                <Label>Comment</Label>
                                <Input type="text"
                                    onChange={handleInputChange}
                                    value={commentValue}
                                    name="commentValue" size="30">{commentDispute}</Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="4">
                            <FormGroup>
                                <Label>file</Label>
                                <div>
                                    {/* <input 
                                    type="file" 
                                     onChange={handleChange}
                                    //  value={selectedFile}
                                     /> */}
                                <Input type="file" onClick={(event) => { event.target.value = null} } onChange={(event) => handleFileChange(event)}/>

                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>}
                </ModalBody>
                            
                <ModalFooter>
                    <Button color="primary" disabled={requesting} onClick={yesAction}>{yesText}</Button>{' '}
                    <Button color="secondary" onClick={toggle}>{noText}</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default DisputeModal;


// WEBPACK FOOTER //
// ./src/views/dispute-log/pop-modal.js